// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__FU2lI","option":"styles_option__1wfxJ","selected":"styles_selected__1BgDY"};